/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import { generatePath, useLocation, useNavigate } from 'react-router-dom';
import { getInputLabel } from './helper';
import { formPaths } from '../../helpers/form';

export const Sections = ({
  formConf = [],
  onChangeForm = () => { },
  group = null,
  subsection = null,
  subgroup = null,
  formid = null,
  match,
  values,
  mod = 'pme',
}) => {
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [formGroups, setFormGroups] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const goTo = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    setFormGroups(formConf);
  }, [formConf]);

  useEffect(() => {
    let sGroup = `${group}${subsection ? `/${subsection}` : ''}${subgroup ? `/${subgroup}` : ''}${formid ? `/${formid}` : ''}`;
    if (!group && formConf.length) {
      sGroup = formConf[0].id;
    }
    if (sGroup) {
      const oKey = sGroup.split('/')[0];
      if (!openKeys.includes(oKey)) {
        openKeys.push(oKey);
      }
      setOpenKeys([
        ...openKeys
      ]);
    }
    setSelectedGroup(sGroup);
  }, [group, subgroup, subsection, formid])

  useEffect(() => {
    if (selectedGroup) {
      const [section, subSection] = selectedGroup.split('/');
      let selectedForm = formGroups.find(f => f.id === section);
      if (selectedForm) {
        if (subSection) {
          selectedForm = selectedForm.items && selectedForm.items[subSection] ? selectedForm.items[subSection] : {};
        }
      } else {
        selectedForm = formGroups.find(f => f.id === selectedGroup);
      }
      onChangeForm(selectedForm);
      if (selectedGroup !== group && selectedGroup) {
        const path = formPaths.edit(mod);
        const [section, subSection, subGroup, formId] = selectedGroup.split('/');

        const _newPath = generatePath(path, { ...match.params, group: section, subsection: subSection, subgroup: subGroup, formid: formId });
        if (pathname !== _newPath) {
          goTo(_newPath);
        }
      }
    } else {
      let sGroup = `${group}${subsection ? `/${subsection}` : ''}${subgroup ? `/${subgroup}` : ''}${formid ? `/${formid}` : ''}`;
      if (!group && formConf.length) {
        sGroup = formConf[0].id;
      }
      setSelectedGroup(sGroup);
    }
  }, [selectedGroup, formGroups])

  return selectedGroup ? (
    <Menu
      mode="inline"
      defaultSelectedKeys={[selectedGroup]}
      selectedKeys={[selectedGroup]}
      defaultOpenKeys={selectedGroup ? [selectedGroup.split('/')[0]] : []}
      openKeys={openKeys}
      onOpenChange={(oKeys) => {
        setOpenKeys(oKeys)
      }}
      style={{ overflowY: 'auto', overflowX: 'hidden' }}
      onSelect={group => {
        setSelectedGroup(group.key);
      }}>
      {formGroups.filter(f => f.show && !f.excludeFromEdit).map(key => key.items && typeof key.items === 'object' && Object.keys(key.items).length > 0 ? (
        <Menu.SubMenu key={key.id} title={getInputLabel(key, values)}>
          {Object.keys(key.items).filter(item => key.items[item].show).map(item => (
            <Menu.Item key={`${key.id}/${item}`} level={2}>{getInputLabel(key.items[item], values)}</Menu.Item>
          ))}
        </Menu.SubMenu>
      ) : (
        <Menu.Item key={key.id}>{getInputLabel(key, values)}</Menu.Item>
      ))}
    </Menu>
  ) : null;
}

